import { IUser } from 'types/users.types';

export const ROLES = {
  superadmin: 'superadmin',
  rabinato: 'rabinato',
  directorio: 'directorio',
  cliente: 'cliente',
};

export const isSuperAdminRole = (user: IUser | null | undefined) =>
  !!user?.roles?.find(({ name }) => name === ROLES.superadmin);

export const isRabinatoRole = (user: IUser | null | undefined) =>
  !!user?.roles?.find(({ name }) => name === ROLES.rabinato);

export const isDirectorioRole = (user: IUser | null | undefined) =>
  !!user?.roles?.find(({ name }) => name === ROLES.directorio);

export const isClienteRole = (user: IUser | null | undefined) =>
  !!user?.roles?.find(({ name }) => name === ROLES.cliente);
